<template>
  <div
    class="my-echart-box"
    style="width: 100%; height: 100%;position:relative"
    ref="chart"
  ></div>
</template>

<script>
// 引入 ECharts 主模块
import * as ECharts from "echarts";
//引入折线图
import "echarts/lib/chart/line";
//引入提示框
import "echarts/lib/component/tooltip";
//引入标题
import "echarts/lib/component/title";
//引入图例标志
import "echarts/lib/component/legend";
import "echarts/lib/component/markLine";
import "echarts/lib/chart/candlestick";

export default {
  props: {
    option: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    init() {
      //2.初始化
      this.chart = ECharts.init(this.$refs.chart);
      //3.配置数据
      // 4.传入数据
      this.chart.setOption(this.option);
    },
  },
  mounted() {
    this.init();
    window.onresize = () => {
      this.chart.resize();
    };
    // console.log("attrs", this.$attrs);
  },
  destroyed() {
    window.onresize = null;
  },
  watch: {
    option: {
      handler(n, o) {
        if (this.chart) {
          this.chart.setOption(this.option);
        }
      },
    },
  },
};
</script>
<style  lang="scss">
.my-echart-box {
  width: 100%;
  div:first-child,
  canvas {
    width: 100% !important;
  }
}
</style>